module.exports = "<div class=\"btn-group\" *ngIf=\"assessmentTest != null && (mode == 'preview' || mode == 'ipp')\">\r\n    <button type=\"button\" class=\"btn btn-default\" (click)=\"showNavigationModal()\">\r\n        Navigation\r\n    </button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/top-nav/nav-button/nav-button.component.html
// module id = iGoV
// module chunks = 1